import { Link } from "react-router-dom";
import { SOCIAL_LINKS } from "../lib/funding";
import { Instagram, Facebook, Youtube, Link as LinkIcon, ExternalLink } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal">
        <p className="eyebrow mb-4">About</p>
        <h1 className="font-display text-6xl md:text-7xl mb-8 leading-[0.95]">
          A family-office trust <br /> marketing concern.
        </h1>
        <div className="text-lg leading-[1.85] max-w-3xl space-y-6" style={{ color: "var(--ink-muted)", fontFamily: "Cormorant Garamond" }}>
          <p>
            <strong style={{ color: "var(--ink)" }}>Wealth First Inc.</strong> — the innovative consulting, marketing,
            reporting, and archiving technology company — designed our platform for the lives of those who quietly
            shape the affluent world: <em style={{ color: "var(--brass)" }}>VCs, Angels, Magnates, Family-Office
            Stewards, Philanthropists, Fortune 100 CEOs, and the Founders of luxury houses.</em>
          </p>
          <p>
            We are here to deliver their wisdom on the record, and their capital strategies into action through
            subscribing to our channel. We are here for visionaries to connect with <strong style={{ color: "var(--ink)" }}>LLPs,
            LPs, GPs, and Proprietaries</strong> — for startups and entrepreneurs of all ages around the world —
            through our secure, user-friendly AI interface.
          </p>
          <p>
            Helping make funding rounds requirements easier — so founders may scale successfully under the correct,
            bullet-proof wealth-building structures and documents. A platform with a focus on{" "}
            <em style={{ color: "var(--brass)" }}>transparency</em> and{" "}
            <em style={{ color: "var(--brass)" }}>accessibility</em> — bridging the gap in capital resources.
          </p>
          <p>
            <span style={{ color: "var(--brass)", letterSpacing: "0.04em" }}>WEALTH FIRST INC.</span> is here to empower
            creators with quiet creditors, guarantors, and grantors — bringing vetted ideas to life, while guiding a
            vibrant community of vested Wealth First subscribers, supporters, and shareholders.
          </p>
        </div>
      </div>

      <hr className="hairline mb-16" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
        <div className="lg:col-span-7">
          <p className="eyebrow mb-4">Our Charter</p>
          <h2 className="font-display text-4xl mb-6">Three pillars.</h2>
          <div className="space-y-8">
            <div>
              <h3 className="font-display text-2xl mb-2" style={{ color: "var(--brass)" }}>Editorial Archive</h3>
              <p className="text-base leading-relaxed" style={{ color: "var(--ink-muted)" }}>
                A subscription television and editorial network capturing long-form interviews and reportage
                with magnates, CEOs, and quiet allocators of capital.
              </p>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-2" style={{ color: "var(--brass)" }}>Funding Portal</h3>
              <p className="text-base leading-relaxed" style={{ color: "var(--ink-muted)" }}>
                AI-powered credit building, lender matching, and revocable-trust automation for founders
                moving from intention to capital with discipline.
              </p>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-2" style={{ color: "var(--brass)" }}>Marketing Consultancy</h3>
              <p className="text-base leading-relaxed" style={{ color: "var(--ink-muted)" }}>
                Quiet brand stewardship for heritage houses, luxury services, and family offices that
                wish to be known carefully, by the right people, in the right rooms.
              </p>
            </div>
          </div>
        </div>
        <aside className="lg:col-span-5 lg:pl-8" style={{ borderLeft: "1px solid var(--hairline)" }}>
          <p className="eyebrow mb-4">Connect</p>
          <ul className="space-y-4 text-sm">
            <li><a href="mailto:support@wealthfirstinc.tv" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors" data-testid="about-email"><span style={{ color: "var(--brass)" }}>✉</span> support@wealthfirstinc.tv</a></li>
            <li><a href={SOCIAL_LINKS.youtube} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors"><Youtube size={18} style={{ color: "var(--brass)" }}/> YouTube · @wealthfirstincTV</a></li>
            <li><a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors"><Instagram size={18} style={{ color: "var(--brass)" }}/> Instagram · @profitwealthfirst</a></li>
            <li><a href={SOCIAL_LINKS.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors"><Facebook size={18} style={{ color: "var(--brass)" }}/> Facebook · wealthfirstinctv</a></li>
            <li><a href={SOCIAL_LINKS.linktree} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors"><LinkIcon size={18} style={{ color: "var(--brass)" }}/> linktr.ee/wealthfirstinc</a></li>
            <li><a href={SOCIAL_LINKS.shoes} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--brass)] transition-colors"><ExternalLink size={18} style={{ color: "var(--brass)" }}/> Alive Shoes — WFI Capsule</a></li>
          </ul>
          <hr className="hairline my-6" />
          <Link to="/contact" className="btn-ghost w-full" data-testid="about-contact-cta" style={{ justifyContent: "center" }}>
            Reach the Editorial Desk
          </Link>
        </aside>
      </div>
    </div>
  );
}
